import React from 'react'
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'
import FormattedCurrency from '../../../../components/ui/FormattedCurrency'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, fiscal_year, fiscal_years = [], journal_entries, filters = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  const applyFilter = (key, value) => {
    const params = new URLSearchParams()
    const newFilters = { ...filters, [key]: value }
    Object.entries(newFilters).forEach(([k, v]) => { if (v) params.set(k, v) })
    router.visit(`${basePath}/journal?${params.toString()}`)
  }

  return (
    <Box>
      <PageHeader
        title="Journal"
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Journal' },
        ]}
        actions={
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => router.visit(`${basePath}/journal/new`)}
            data-testid="new-journal-entry-btn"
          >
            Buchung erfassen
          </Button>
        }
      />

      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Geschäftsjahr</InputLabel>
          <Select value={filters.fiscal_year_id || ''} label="Geschäftsjahr"
            onChange={(e) => applyFilter('fiscal_year_id', e.target.value)}
            data-testid="fiscal-year-filter"
          >
            {fiscal_years.map((fy) => (
              <MenuItem key={fy.id} value={fy.id}>{fy.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Status</InputLabel>
          <Select value={filters.status || ''} label="Status"
            onChange={(e) => applyFilter('status', e.target.value)}
            data-testid="status-filter"
          >
            <MenuItem value="">Alle</MenuItem>
            <MenuItem value="draft">Entwurf</MenuItem>
            <MenuItem value="posted">Gebucht</MenuItem>
            <MenuItem value="reversed">Storniert</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Buchungsart</InputLabel>
          <Select value={filters.entry_type || ''} label="Buchungsart"
            onChange={(e) => applyFilter('entry_type', e.target.value)}
            data-testid="entry-type-filter"
          >
            <MenuItem value="">Alle</MenuItem>
            <MenuItem value="standard">Standard</MenuItem>
            <MenuItem value="opening">Eröffnung</MenuItem>
            <MenuItem value="closing">Abschluss</MenuItem>
            <MenuItem value="reversal">Storno</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Nr.</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Datum</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Beschreibung</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Art</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Soll</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Haben</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {journal_entries.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Buchungen vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {journal_entries.map((je) => (
              <TableRow key={je.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`${basePath}/journal/${je.id}`)}
              >
                <TableCell>{je.entry_number}</TableCell>
                <TableCell>{je.entry_date}</TableCell>
                <TableCell>{je.description}</TableCell>
                <TableCell>{je.entry_type}</TableCell>
                <TableCell><StatusBadge type="journal_entry_status" value={je.status} /></TableCell>
                <TableCell align="right"><FormattedCurrency value={je.total_debit} /></TableCell>
                <TableCell align="right"><FormattedCurrency value={je.total_credit} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
